enum Byte {
  Kb = 1_000,
  Mb = 1_000 * Byte.Kb,
  Gb = 1_000 * Byte.Mb,
}

export const MAX_BODY_SIZE = 10 * Byte.Mb;
export const SYMBOL_SIZE = 4;
